import React, { useState, useEffect, useRef } from "react";
import api from "./api";

// Voice input using Web Speech API
const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;

export default function App() {
  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const chatEndRef = useRef(null);

  // Auto scroll down
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat, isTyping]);

  // Voice input handler
  const handleVoiceInput = () => {
    if (!SpeechRecognition) {
      alert("Speech recognition not supported in your browser");
      return;
    }
    const recognition = new SpeechRecognition();
    recognition.lang = "hi-IN"; // Hindi / Chhattisgarhi
    recognition.start();
    setIsListening(true);

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setMessage(transcript);
      setIsListening(false);
    };

    recognition.onerror = () => {
      setIsListening(false);
      alert("Voice input failed. Try again.");
    };
  };

  // Text-to-speech (bot reply बोलता है)
  const speakText = (text) => {
    const speech = new SpeechSynthesisUtterance(text);
    speech.lang = "hi-IN"; // Hindi language for voice output
    speech.rate = 1;
    window.speechSynthesis.speak(speech);
  };

  // Send Message
  const sendMessage = async () => {
    if (!message.trim()) return;
    const userMsg = { user: message };
    setChat((prev) => [...prev, userMsg]);
    setMessage("");
    setIsTyping(true);

    try {
      const res = await api.post("/chat", { message });
      const reply = res.data.choices?.[0]?.message?.content || "समझ नइ परे 😅";
      setChat((prev) => [...prev, userMsg, { bot: reply }]);
      speakText(reply); // 🔊 bot बोलेगा
    } catch (err) {
      setChat((prev) => [...prev, { bot: "Server error 😓" }]);
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      {/* Header */}
      <nav className="navbar navbar-dark bg-primary shadow">
        <div className="container-fluid justify-content-center">
          <span className="navbar-brand mb-0 h1 text-center">
            🪔 MorCG AI — Aapan Boli, Aapan AI
          </span>
        </div>
      </nav>

      {/* Chat Window */}
      <div className="container my-4 flex-grow-1 d-flex flex-column justify-content-between">
        <div
          className="border bg-white rounded p-3 mb-3 overflow-auto"
          style={{ height: "70vh" }}
        >
          {chat.map((msg, i) => (
            <div
              key={i}
              className={`d-flex mb-3 ${
                msg.user ? "justify-content-end" : "justify-content-start"
              }`}
            >
              <div
                className={`p-3 rounded-3 shadow-sm ${
                  msg.user
                    ? "bg-primary text-white rounded-end-0"
                    : "bg-light text-dark rounded-start-0"
                }`}
                style={{ maxWidth: "75%" }}
              >
                {msg.user || msg.bot}
              </div>
            </div>
          ))}

          {isTyping && (
            <div className="text-muted fst-italic">MorCG टाइप करत हव...</div>
          )}

          <div ref={chatEndRef}></div>
        </div>

        {/* Input Controls */}
        <div className="input-group shadow">
          <button
            className={`btn ${isListening ? "btn-danger" : "btn-outline-secondary"}`}
            onClick={handleVoiceInput}
            title="Speak your message"
          >
            🎤
          </button>
          <input
            type="text"
            className="form-control"
            placeholder="बोलव न भाई... ✍️"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button className="btn btn-primary" onClick={sendMessage}>
            Send
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="text-center text-muted py-2 bg-white border-top">
        © 2025 MorCG AI | Built with ❤️ in Chhattisgarh
      </footer>
    </div>
  );
}
